import * as Mui from "@mui/material";
import { Route, Routes } from "react-router";
import { DeliveryDetatilsPage } from "../component/deliveryNote/DeliveryDetatilsPage";
import { DeliveryNoteTable } from "../component/deliveryNote/DeliveryNoteTable";
import { IFilterDeliveryNote } from "../component/deliveryNote/service/DeliveryNoteServices";
import { useForm } from "react-hook-form";
import ManipulateLocation from "../component/deliveryNote/ManipulateLocation";

export const DeliveryNotePage = () => {
  const form = useForm<IFilterDeliveryNote>({
    defaultValues: {
      startDateFrom: null,
      startDateTo: null,
      endDateFrom: null,
      endDateTo: null,
    },
  });
  return (
    <ManipulateLocation>
      <Routes>
        <Route index={true} element={<DeliveryNoteTable form={form} />} />
        <Route path="/details/:id/*" element={<DeliveryDetatilsPage />} />
      </Routes>
    </ManipulateLocation>
  );
};
